import { render, staticRenderFns } from "./FeedbackContacts.vue?vue&type=template&id=a447f976"
import script from "./FeedbackContacts.vue?vue&type=script&lang=ts"
export * from "./FeedbackContacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports